module.exports = __webpack_public_path__ + "public/images/Illustration_Globe_200x200-Color.31f9fbe19997d629bdc16bc2a8ecb79a.png";